<!-- NS-9814, New Page, PW -->
<template>
<div>
  <Navbar />
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper">
        <h6 class="element-header">{{ t('pricipalsReportDelRulesTitle', 'pricipalsReportDelRulesTitle')}}</h6>
        <div class="row">
          <div class="col-lg-2 col-md-3 element-box mt-2">
            <div class="col-12 px-0 form-group">
              <div class="element-info pb-0">
                <h5>{{ t('principleListText', 'principleListText') }}</h5>
                <hr class="mb-1">
                <div class="col-12 px-0 principle-list pb-2 mb-1">
                  <div v-if="principleList" class="col-12 px-0">
                    <div class="col-12 px-0 mb-1 principle-btn" v-for="principle in principleList" :key="principle.id">
                      <a href="javascript:;" class="btn btn-primary" @click="getPrincipleReportRules(principle.id); setPrincipleHeader(principle.principle, principle.id)">{{ principle.principle }}</a>
                    </div>
                  </div>
                  <div v-else>
                    {{ t('noPrincipleAvailableText', 'noPrincipleAvailableText') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedPrinciple" class="col-lg-7 col-md-8 ml-1 element-box mt-2">
            <div class="col-12">
              <template>
                <div class="element-info pb-0">
                  <h5>{{ t('selectedPrincipleReport', 'selectedPrincipleReport') }} {{ selectedPrinciple }}</h5>
                  <hr>
                  <div class="row text-center">
                    <b-row class="col-12 py-0 mb-3">                      
                      <b-col sm="4 rule-label"><label for="proofReportsEmail">{{ t('principleDeliveryRylesProofRepEmail', 'principleDeliveryRylesProofRepEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="proofReportsEmail" placeholder="" v-model="proofReportsEmail"></b-form-input></b-col>
                    </b-row>
                    <b-row class="col-12 mb-3">                      
                      <b-col sm="4 rule-label"><label for="proofReminderEmail">{{ t('principleDeliveryRylesProofReminderEmail', 'principleDeliveryRylesProofReminderEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="proofReminderEmail" placeholder="" v-model="proofReminderEmail"></b-form-input></b-col>
                    </b-row>
                    <b-row class="col-12 mb-3">                      
                      <b-col sm="4 rule-label"><label for="startReportsEmail">{{ t('principleDeliveryRylesProofStartEmail', 'principleDeliveryRylesProofStartEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="startReportsEmail" placeholder="" v-model="startReportsEmail"></b-form-input></b-col>
                    </b-row>
                    <b-row class="col-12 mb-3">                      
                      <b-col sm="4 rule-label"><label for="progressReportsEmail">{{ t('principleDeliveryRylesProofProgressEmail', 'principleDeliveryRylesProofProgressEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="progressReportsEmail" placeholder="" v-model="progressReportsEmail"></b-form-input></b-col>
                    </b-row>
                    <b-row class="col-12 mb-3">
                      <b-col sm="4 rule-label"><label for="finalReportsEmail">{{ t('principleDeliveryRylesProofFinalEmail', 'principleDeliveryRylesProofFinalEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="finalReportsEmail" placeholder="" v-model="finalReportsEmail"></b-form-input></b-col>
                    </b-row>
                    <b-row class="col-12 py-0 mb-3">
                      <b-col sm="4 rule-label"><label for="queryEmail">{{ t('principleDeliveryRylesProofQueryEmail', 'principleDeliveryRylesProofQueryEmail') }}</label></b-col>
                      <b-col sm="8"><b-form-input id="queryEmail" placeholder="" v-model="queryEmail"></b-form-input></b-col>
                    </b-row>
                  </div>
                  <div class="col-12 text-right">                    
                    <small>{{ t('principleReportRulesMultipleEmailLabel', 'principleReportRulesMultipleEmailLabel') }}</small>
                  </div>
                  <ResponseInfo v-if="getResponseInfo.responseName == 'principalMngDelReportsRules'" class="mt-3"/>
                  <div class="col-12 my-2 text-right">
                    <button class="btn btn-primary" @click="updatePrincipleDeliveryReportRules()">{{ t('btnUpdateText', 'btnUpdateText') }}</button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Footer />
</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Helper_Components/Footer'
import ResponseInfo from '@/components/ResponseInfo'
import { mapGetters } from 'vuex'

export default {
  name: 'PrincipalsReportDeliveryRules',
  data() {
    return {
      principleList: null,
      isLoadingPrinciples: false,
      isLoadingRules: false,
      selectedPrinciple: null,
      principleId: null,
      proofReportsEmail: null,
      proofReminderEmail: null,
      startReportsEmail: null,
      progressReportsEmail: null,
      finalReportsEmail: null,
      queryEmail: null
    }
  },
  computed:{
      ...mapGetters(['allTemplateDetails', 'getUserDetails','getIsNewsnet', 'getResponseInfo']),
  },
  components: {
      Navbar,
      ResponseInfo,
      Footer
  },
  created() {
    this.getPrincipalsList()
  },
  methods: {
    getPrincipalsList() {
      this.$store.dispatch("principalStore/getReportRulesPrinciples").then(response => {
        this.principleList = response
      })
    },
    setPrincipleHeader(principle, id) {
      this.selectedPrinciple = principle
      this.principleId = id
    },
    getPrincipleReportRules(id) {
      this.proofReportsEmail = null
      this.proofReminderEmail = null
      this.startReportsEmail = null
      this.progressReportsEmail = null
      this.finalReportsEmail = null
      this.queryEmail = null

      this.$store.dispatch("principalStore/getPrincipleReportRules", id).then(response => {
        if(response) {
          this.proofReportsEmail = response.proof
          this.proofReminderEmail = response.proof_reminder
          this.startReportsEmail = response.start
          this.progressReportsEmail = response.progress
          this.finalReportsEmail = response.final
          this.queryEmail = response.query
        }
      })
    },
    updatePrincipleDeliveryReportRules() {
      this.$store.dispatch("principalStore/updatePrincipleDeliveryReportRules", 
      {
        principleId: this.principleId,
        proof: this.proofReportsEmail,
        proof_reminder: this.proofReminderEmail,
        start: this.startReportsEmail,
        progress: this.progressReportsEmail,
        final: this.finalReportsEmail,
        query: this.queryEmail
      }).then(response => {

      })
    }
  }
}
</script>

<style scoped>
  .principle-list {
    height: 400px;
    overflow-y: auto;
  }
  .principle-btn > a {
    width: 100%;
    color: white;
  }
  .rule-label {
    display: flex;
    align-items: center;
  }
</style>
